import { render, staticRenderFns } from "./sharFrom.vue?vue&type=template&id=ff6afa7e&scoped=true"
import script from "./sharFrom.vue?vue&type=script&lang=js"
export * from "./sharFrom.vue?vue&type=script&lang=js"
import style0 from "./sharFrom.vue?vue&type=style&index=0&id=ff6afa7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6afa7e",
  null
  
)

export default component.exports